export class ViaAdministration {
    name: string;
    id: number;
    code: string;
}